import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopandharpurdarshan() {



    const cardData = {

keyword: "Pune to Pandharpur Darshan",

headingDescription:
    "Rising Cab Service offers comfortable and reliable Pune to Pandharpur Darshan services for devotees, families, and groups visiting the holy town of Lord Vitthal. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles with experienced drivers for a safe and smooth pilgrimage journey. Our service includes flexible one-way and round-trip options, doorstep pickup from Pune, transparent pricing, and 24/7 booking support. Rising Cab Service ensures a peaceful and devotional travel experience to Pandharpur.",

topPlaces: [
    {
        title: "Shri Vitthal Rukmini Temple",
        description:
            "Shri Vitthal Rukmini Temple is the main attraction of Pandharpur and one of the most important pilgrimage sites in Maharashtra. Dedicated to Lord Vitthal (an incarnation of Lord Krishna), the temple attracts लाखो devotees, especially during Ashadhi Ekadashi. The temple is known for its spiritual atmosphere and traditional Warkari devotion."
    },
    {
        title: "Chandrabhaga River Ghat",
        description:
            "Chandrabhaga River Ghat is a sacred bathing place for pilgrims visiting Pandharpur. Devotees take holy dips in the river before visiting the Vitthal temple, believing it purifies the soul and brings spiritual blessings."
    },
    {
        title: "Pundalik Temple",
        description:
            "Pundalik Temple is dedicated to Saint Pundalik, who is believed to have brought Lord Vitthal to Pandharpur. The temple holds great mythological importance and is an essential part of the Pandharpur pilgrimage."
    },
    {
        title: "Kaikadi Maharaj Math",
        description:
            "Kaikadi Maharaj Math is a spiritual center known for its unique sculptures and devotional teachings. The temple complex showcases scenes from Hindu mythology and attracts devotees and tourists alike."
    },
    {
        title: "ISKCON Pandharpur",
        description:
            "ISKCON Pandharpur is a peaceful temple dedicated to Lord Krishna and Radha. It offers devotional programs, kirtans, and spiritual activities in a calm and well-maintained environment."
    },
    {
        title: "Vishnupad Temple",
        description:
            "Vishnupad Temple is another sacred site in Pandharpur associated with Lord Vishnu worship. It is visited by devotees seeking blessings and spiritual peace during their pilgrimage."
    },
    {
        title: "Gajanan Maharaj Math",
        description:
            "Gajanan Maharaj Math is a revered spiritual place dedicated to Saint Gajanan Maharaj. The temple is known for its peaceful surroundings and devotional atmosphere."
    },
    {
        title: "Pandharpur Wari Route",
        description:
            "The Pandharpur Wari Route is the sacred path taken by thousands of Warkaris during the annual pilgrimage to Pandharpur. It represents devotion, unity, and spiritual discipline across Maharashtra."
    },
    {
        title: "Takpithya Vithoba Mandir",
        description:
            "Takpithya Vithoba Mandir is a small but significant temple in Pandharpur dedicated to Lord Vitthal. It is visited by devotees for a quieter and more personal spiritual experience."
    },
    {
        title: "Sant Tukaram Temple Area",
        description:
            "The Sant Tukaram Temple area reflects the teachings and legacy of the great saint Tukaram Maharaj. It is an important cultural and devotional spot connected to the Bhakti movement in Maharashtra."
    }
],



services: [
    {
        name: "Pune to Pandharpur Darshan",
        description:
            "Rising Cab Service offers Pune to Pandharpur Darshan with comfortable and reliable cab facilities for devotees visiting Lord Vitthal temple. Our service ensures a smooth spiritual journey with well-maintained AC vehicles, experienced drivers, doorstep pickup and drop from Pune, and flexible travel schedules suitable for families, groups, and senior citizens. We focus on providing a safe, peaceful, and hassle-free pilgrimage experience with complete travel assistance and timely service throughout the journey."
    },
    {
        name: "Pune to Pandharpur Darshan Package",
        description:
            "Book Pune to Pandharpur Darshan Package with Rising Cab Service for a complete pilgrimage experience covering all major temple visits and spiritual destinations. Our package includes comfortable cab travel, experienced drivers familiar with temple routes, flexible waiting time for darshan, and customized itineraries suitable for families and groups. We ensure a smooth and well-planned journey with affordable pricing and 24x7 booking support."
    },
    {
        name: "Pune to Pandharpur Cab Service",
        description:
            "Rising Cab Service provides Pune to Pandharpur Cab Service for devotees seeking safe and comfortable travel to Pandharpur. Our fleet includes sedans, SUVs, Innova Crysta, and tempo travellers, ensuring options for every group size. With professional drivers, clean vehicles, and flexible pickup and drop locations, we guarantee a reliable and stress-free travel experience for all passengers."
    },
    {
        name: "Pune to Pandharpur Taxi Service",
        description:
            "Our Pune to Pandharpur Taxi Service is designed for pilgrims and travelers looking for convenient and affordable transportation. Rising Cab Service ensures timely pickup, smooth highway travel, and safe driving with experienced chauffeurs. Whether it is a one-way trip or round trip, we provide flexible booking options and comfortable vehicles for a pleasant journey."
    },
    {
        name: "Pune to Pandharpur Tour Package",
        description:
            "Rising Cab Service offers Pune to Pandharpur Tour Package designed for devotional travelers who want a complete and well-organized pilgrimage experience. Our package includes sightseeing assistance, temple darshan support, comfortable cab travel, and customized itineraries. We ensure a peaceful and spiritually fulfilling journey with professional service throughout."
    },
    {
        name: "Pune to Pandharpur Cab Booking",
        description:
            "Book Pune to Pandharpur Cab Booking easily with Rising Cab Service through online or offline modes. We provide instant confirmation, transparent pricing, and multiple vehicle options for a comfortable travel experience. Our service ensures reliable transportation for families, groups, and individual travelers visiting Pandharpur."
    },
    {
        name: "Pune to Pandharpur One Day Trip",
        description:
            "Rising Cab Service offers Pune to Pandharpur One Day Trip for travelers who want a quick and comfortable pilgrimage experience. Our one-day package includes early pickup from Pune, smooth travel, temple darshan at Pandharpur, and return journey on the same day with experienced drivers ensuring timely service."
    },
    {
        name: "Pune to Pandharpur Car Rental",
        description:
            "Our Pune to Pandharpur Car Rental service provides flexible travel options with well-maintained vehicles and professional drivers. Rising Cab Service ensures comfort, safety, and affordability for all types of travelers including families, groups, and senior citizens planning a pilgrimage to Pandharpur."
    },
    {
        name: "Pune to Pandharpur Darshan Tour",
        description:
            "Rising Cab Service offers Pune to Pandharpur Darshan Tour with complete travel arrangements for a smooth spiritual journey. Our service includes temple visit assistance, comfortable cab travel, and experienced drivers who ensure a hassle-free and peaceful pilgrimage experience."
    },
    {
        name: "Pandharpur Darshan from Pune",
        description:
            "Book Pandharpur Darshan from Pune with Rising Cab Service for a convenient and well-organized pilgrimage. We provide door-to-door pickup, AC vehicles, and flexible travel schedules ensuring a comfortable journey for families and devotees visiting Lord Vitthal."
    },
    {
        name: "Pune to Pandharpur Cab",
        description:
            "Rising Cab Service provides Pune to Pandharpur Cab for safe and comfortable travel with multiple vehicle options. Our service ensures reliable transportation, professional drivers, and flexible booking options for a smooth pilgrimage experience."
    },
    {
        name: "Pune to Pandharpur Taxi",
        description:
            "Our Pune to Pandharpur Taxi service offers affordable and convenient travel solutions for devotees and tourists. With clean vehicles and experienced drivers, we ensure a safe and enjoyable journey to Pandharpur."
    },
    {
        name: "Pune to Pandharpur Outstation Cab",
        description:
            "Rising Cab Service offers Pune to Pandharpur Outstation Cab for long-distance travel with comfort and safety. Our service includes flexible pickup, professional drivers, and well-maintained vehicles suitable for family and group travel."
    },
    {
        name: "Pune to Pandharpur Round Trip Cab",
        description:
            "Book Pune to Pandharpur Round Trip Cab with Rising Cab Service for a complete pilgrimage journey including pickup, temple darshan, waiting time, and return travel with experienced drivers ensuring smooth service."
    },
    {
        name: "Pune to Pandharpur One Way Cab",
        description:
            "Rising Cab Service provides Pune to Pandharpur One Way Cab for budget-friendly travel options without return booking requirements. Our service ensures comfort, safety, and timely arrival at your destination."
    },
    {
        name: "Pune to Pandharpur Car Hire",
        description:
            "Our Pune to Pandharpur Car Hire service offers flexible and comfortable travel options with experienced drivers and clean vehicles, ideal for families and group pilgrimage trips."
    },
    {
        name: "AC Cab Pune to Pandharpur",
        description:
            "Rising Cab Service provides AC Cab Pune to Pandharpur for a comfortable and pleasant journey with air-conditioned vehicles, ensuring a relaxing travel experience for all passengers."
    },
    {
        name: "Online Cab Booking Pune to Pandharpur",
        description:
            "Book Online Cab Booking Pune to Pandharpur easily with Rising Cab Service through a quick and user-friendly booking system with instant confirmation and transparent pricing."
    },
    {
        name: "Best Cab Service Pune to Pandharpur",
        description:
            "Rising Cab Service offers Best Cab Service Pune to Pandharpur with reliable drivers, clean vehicles, affordable pricing, and excellent customer support for a smooth pilgrimage journey."
    },
    {
        name: "Pandharpur Tuljapur Akkalkot Gangapur Darshan Package",
        description:
            "Rising Cab Service provides Pandharpur Tuljapur Akkalkot Gangapur Darshan Package covering multiple spiritual destinations in Maharashtra with comfortable cab travel and experienced drivers for a complete devotional tour."
    },
    {
        name: "Pandharpur Tuljapur Akkalkot Tour Package",
        description:
            "Book Pandharpur Tuljapur Akkalkot Tour Package with Rising Cab Service for a well-planned pilgrimage covering major holy temples with flexible itinerary and comfortable transportation."
    },
    {
        name: "Akkalkot Gangapur Darshan Package from Pune",
        description:
            "Rising Cab Service offers Akkalkot Gangapur Darshan Package from Pune with complete travel arrangements, ensuring a smooth and spiritual journey for devotees."
    },
    {
        name: "Pune to Dattatreya Darshan Package",
        description:
            "Our Pune to Dattatreya Darshan Package provides a peaceful pilgrimage experience with comfortable cab travel and temple visit assistance for devotees."
    },
    {
        name: "Pune to Swami Samarth Darshan Package",
        description:
            "Rising Cab Service offers Pune to Swami Samarth Darshan Package with reliable transportation and flexible travel schedules for a spiritual and comfortable journey."
    },
    {
        name: "Pune to Pandharpur Tuljapur Akkalkot Gangapur Cab Service",
        description:
            "Book Pune to Pandharpur Tuljapur Akkalkot Gangapur Cab Service with Rising Cab Service for a complete multi-destination pilgrimage tour with safe, comfortable, and well-organized travel arrangements."
    }
],

tableData: [
    ["Pune to Pandharpur Darshan", "Pune to Pandharpur Darshan Package"],
    ["Pune to Pandharpur Cab Service", "Pune to Pandharpur Taxi Service"],
    ["Pune to Pandharpur Tour Package", "Pune to Pandharpur Cab Booking"],
    ["Pune to Pandharpur One Day Trip", "Pune to Pandharpur Car Rental"],
    ["Pune to Pandharpur Darshan Tour", "Pandharpur Darshan from Pune"],
    ["Pune to Pandharpur Cab", "Pune to Pandharpur Taxi"],
    ["Pune to Pandharpur Outstation Cab", "Pune to Pandharpur Round Trip Cab"],
    ["Pune to Pandharpur One Way Cab", "Pune to Pandharpur Car Hire"],
    ["AC Cab Pune to Pandharpur", "Online Cab Booking Pune to Pandharpur"],
    ["Best Cab Service Pune to Pandharpur", "Pandharpur Tuljapur Akkalkot Gangapur Darshan Package"],
    ["Pandharpur Tuljapur Akkalkot Tour Package", "Akkalkot Gangapur Darshan Package from Pune"],
    ["Pune to Dattatreya Darshan Package", "Pune to Swami Samarth Darshan Package"],
    ["Pune to Pandharpur Tuljapur Akkalkot Gangapur Cab Service", "Pune to Pandharpur Darshan Package"]
],


whychoose: [
    {
        WhyChooseheading: "Spiritual Journey to Lord Vitthal's Holy City",
        WhyChoosedescription: "Rising Cab Service offers dedicated Pune to Pandharpur Darshan trips for devotees seeking a peaceful and comfortable pilgrimage to the sacred town of Pandharpur."
    },
    {
        WhyChooseheading: "Travel at Your Preferred Schedule",
        WhyChoosedescription: "Whether you wish to start early morning, travel overnight, or plan a same-day return journey, we provide flexible travel schedules to match your convenience."
    },
    {
        WhyChooseheading: "Well-Maintained Fleet for Temple Tours",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and Mini Buses that are regularly serviced for safe and comfortable travel."
    },
    {
        WhyChooseheading: "Suitable for Individual and Group Pilgrimages",
        WhyChoosedescription: "Our Pune to Pandharpur Darshan service caters to solo devotees, families, senior citizens, religious groups, and large pilgrimage gatherings."
    },
    {
        WhyChooseheading: "Convenient Doorstep Pickup Service",
        WhyChoosedescription: "Pickup facilities are available from homes, hotels, Pune Airport, Railway Station, and all major locations across Pune and Pimpri Chinchwad."
    },
    {
        WhyChooseheading: "Dedicated Assistance Throughout the Trip",
        WhyChoosedescription: "Our team ensures smooth travel arrangements, helping devotees focus on their spiritual journey without transportation concerns."
    },
    {
        WhyChooseheading: "Budget-Friendly Darshan Packages",
        WhyChoosedescription: "Rising Cab Service provides economical Pune to Pandharpur Darshan packages without compromising on travel quality and comfort."
    },
    {
        WhyChooseheading: "Trusted Choice for Religious Travel",
        WhyChoosedescription: "Many devotees rely on our service for regular temple visits due to our punctuality, reliability, and commitment to customer satisfaction."
    }
]
};

const faqData = [
    {
        question: "Why is Pandharpur considered a major pilgrimage destination?",
        answer: "Pandharpur is home to the famous Shri Vitthal-Rukmini Temple and attracts lakhs of devotees from across India throughout the year."
    },
    {
        question: "How much travel time is generally required from Pune to Pandharpur?",
        answer: "The journey typically takes around 4 to 5 hours depending on road conditions and the chosen route."
    },
    {
        question: "Can devotees complete darshan and return on the same day?",
        answer: "Yes, same-day return trips are one of the most popular options selected by pilgrims visiting Pandharpur."
    },
    {
        question: "Which vehicle category is recommended for family darshan trips?",
        answer: "Ertiga and Innova Crysta are commonly preferred by families because of their spacious seating and travel comfort."
    },
    {
        question: "Are large group vehicles available for Wari and temple visits?",
        answer: "Yes, Tempo Travellers and Mini Buses can be arranged for religious groups and larger gatherings."
    },
    {
        question: "Can additional temples be included during the journey?",
        answer: "Yes, travel plans can be customized to include nearby religious destinations depending on your itinerary."
    },
    {
        question: "Is advance reservation recommended during Ashadhi and Kartiki Ekadashi?",
        answer: "Yes, advance booking is strongly recommended because demand increases significantly during major pilgrimage seasons."
    },
    {
        question: "What facilities are available in the vehicles?",
        answer: "Our vehicles are equipped with comfortable seating, air conditioning, ample luggage space, and professional driver support."
    },
    {
        question: "Do senior citizens frequently use this service?",
        answer: "Yes, many senior citizens prefer our service due to comfortable vehicles and convenient door-to-door transportation."
    },
    {
        question: "What is the easiest way to confirm a Pune to Pandharpur Darshan booking?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp inquiries, or direct online reservation with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Mahadev Chavan",
        feedback:
            "The darshan trip to Pandharpur was organized beautifully. Everything from pickup timing to return travel was managed efficiently, making the pilgrimage truly enjoyable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishali Mane",
        feedback:
            "My parents and relatives were extremely comfortable throughout the journey. The vehicle condition, driver behavior, and overall coordination were excellent.",
        rating: 5
    }
];













    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Pandharpur Darshan Package",
"image": "https://www.risingcabservice.com/assets/images/pune-to-pandharpur-darshan-package.jpg",
"description": "Book Pune to Pandharpur Darshan Package with Rising Cab Service for comfortable pilgrimage travel to Lord Vitthal temple. Enjoy safe, affordable, and reliable cab service for one-day trips, round trips, and spiritual tours from Pune.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-pandharpur-darshan-package"
}
};





    return (
        <div>
<Helmet>
  <title>Pune to Pandharpur Darshan Package | Vitthal Temple Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Pandharpur Darshan Package for Vitthal Rukmini temple visit. Comfortable AC cab service for one-day trip, round trip, and pilgrimage travel from Pune to Pandharpur."
/>

<meta
 name="keywords"
 content="Pune to Pandharpur Darshan, Pune to Pandharpur Darshan Package, Pune to Pandharpur Cab Service, Pune to Pandharpur Taxi Service, Pune to Pandharpur Tour Package, Pune to Pandharpur Cab Booking, Pune to Pandharpur One Day Trip, Pune to Pandharpur Car Rental, Pune to Pandharpur Darshan Tour, Pandharpur Darshan from Pune, Pune to Pandharpur Cab, Pune to Pandharpur Taxi, Pune to Pandharpur Outstation Cab, Pune to Pandharpur Round Trip Cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetopandharpurdarshan;